import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import NavigationBar from "@/components/landing/NavigationBar";
import Footer from "@/components/landing/Footer";

const CookiePolicy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Check if we need to scroll to a specific section
    if (location.state && location.state.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <NavigationBar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-white hover:bg-white/10"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <h1 className="text-3xl font-bold mb-8 text-white">Cookie Policy</h1>
        
        <div className="space-y-6">
          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">What Are Cookies</h2>
            <p className="text-gray-300 mb-4">
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. 
              They are widely used to make websites work more efficiently and provide information to the owners of the site.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">How We Use Cookies</h2>
            <p className="text-gray-300 mb-4">
              We use cookies to understand how you use our site and to improve your experience. This includes:
            </p>
            <ul className="list-disc pl-8 text-gray-300 mb-4 space-y-2">
              <li>Remembering your preferences and settings</li>
              <li>Keeping you signed in</li>
              <li>Understanding how you use our platform</li>
              <li>Measuring the effectiveness of our content</li>
            </ul>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Types of Cookies We Use</h2>
            <p className="text-gray-300 mb-4">
              We use both session cookies, which expire when you close your browser, and persistent cookies, 
              which stay on your device until they expire or you delete them.
            </p>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Essential Cookies</h3>
                <p className="text-gray-300">
                  These are necessary for the website to function properly and cannot be switched off in our systems.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Analytics Cookies</h3>
                <p className="text-gray-300">
                  These help us understand how visitors interact with our website by collecting and reporting information anonymously.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Functional Cookies</h3>
                <p className="text-gray-300">
                  These enable the website to provide enhanced functionality and personalization based on your interactions.
                </p>
              </div>
            </div>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Managing Cookies</h2>
            <p className="text-gray-300 mb-4">
              Most web browsers allow you to control cookies through their settings preferences. 
              However, limiting cookies may impact your experience and functionality of our platform.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Related Policies</h2>
            <p className="text-gray-300 mb-4">
              Please also review our <Link to="/privacy" className="text-blue-400 hover:underline">Privacy Policy</Link>, 
              <Link to="/terms" className="text-blue-400 hover:underline"> Terms of Service</Link>, and 
              <Link to="/data-processing" className="text-blue-400 hover:underline"> Data Processing Agreement</Link>.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Changes to This Cookie Policy</h2>
            <p className="text-gray-300 mb-4">
              We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new 
              Cookie Policy on this page.
            </p>
            <p className="text-gray-300 mb-4">
              Last updated: May 1, 2023
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CookiePolicy;
